import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { RedirectionService } from '~/core/services/redirection/redirection.service';
import { BookingService } from '~/checkout/services/booking/booking.service';

@Component({
  selector: 'app-redirect-booking',
  templateUrl: './redirect-booking.component.html',
  styleUrls: ['./redirect-booking.component.scss'],
})
export class RedirectBookingComponent implements OnDestroy, OnInit {
  @ViewChild('redirectButton') redirectButton: ElementRef<HTMLElement>;

  private readonly subscriptions = new Subscription();
  private paymentIntent: string;

  public url: string;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: string,
    protected readonly activatedRoute: ActivatedRoute,
    private readonly redirectionService: RedirectionService,
    private readonly translateService: TranslateService,
    private readonly bookingService: BookingService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public get redirectionTitle(): string {
    return this.translateService.instant('checkout.confirmation.title');
  }

  public ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.paymentIntent = queryParams?.payment_intent;
    });
    this.subscriptions.add(
      this.activatedRoute.data.subscribe(({ bookingId }) => {
        this.bookingService
          .getStatus(bookingId?.id, this.paymentIntent)
          .subscribe({
            next: (paymentResponse: { status: string }) => {
              if (paymentResponse?.status === 'success') {
                this.redirectionService.redirect(
                  'checkout.confirmation.success'
                );
              } else {
                this.redirectionService.redirect('checkout.failure');
              }
            },
            error: () => {
              this.redirectionService.redirect('checkout.failure');
            },
          });
      })
    );
  }
}
